import React, { useEffect } from "react";
import { DataGrid, deDE, GridColDef, GridRowParams, GridSortModel, LocalizationV4 } from "@material-ui/data-grid";
//import Tooltip from '@material-ui/core/Tooltip';
import Grid from "@material-ui/core/Grid";

import {
  Button,
  Container,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  getSchaltfelder,
  selectSchaltfeldListe,
  selectEditEntry,
  selectNewEntry,
  selectAktuellesSchaltfeld,
  selectViewMode,
  selectEditDirty,
  setEditEntry,
  updateAktuellesSchaltfeld,
  createSchaltfeld,
  updateSchaltfeld,
  setName,
  setNummer,
  setUmspannwerk,
  setKommentar,
  discardNew,
  discardChanges,
  startNewEntry,
  deleteSchaltfeld,
  setError,
  resetError,
  selectError,
  schaltfeldDummy,
  selectUWs,
  getUWs,
  selectListLoading,
  selectUmspannwerkLoading,
  selectSorting,
  setSorting,
  resetViewMode
} from "./schaltfelderSlice";

import { useStyles } from "./../wertelisteStyles";
import { useMsal } from "@azure/msal-react";
import { schaltfeld, umspannwerk } from "../../../../utils/apiTypes";
import { rollen, isAuthorized } from "../../../../utils/auth/authConfig";
import { validate, validateHelper } from "../../../../features/validate/validate";
import { globalStyles } from "../../../../assets/globalStyles";
import { Autocomplete } from "@material-ui/lab";


export const Schaltfelder: React.FC = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const rollenObj = rollen;
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  useEffect(() => {
    dispatch(getSchaltfelder())
    dispatch(getUWs())
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const
    schaltfeldSelectListe: schaltfeld[] = useAppSelector(selectSchaltfeldListe),
    uwSelectList: umspannwerk[] = useAppSelector(selectUWs),
    editEntry: boolean = useAppSelector(selectEditEntry),
    newEntry: boolean = useAppSelector(selectNewEntry),
    aktuellesSchaltfeld: schaltfeld = useAppSelector(selectAktuellesSchaltfeld),
    viewMode: boolean = useAppSelector(selectViewMode),
    dirtyEdit: number = useAppSelector(selectEditDirty),
    inputError: boolean = useAppSelector(selectError),
    listLoading: boolean = useAppSelector(selectListLoading),
    uwLoading: boolean = useAppSelector(selectUmspannwerkLoading),
    sorting: GridSortModel = useAppSelector(selectSorting);

  const dataGridCols2: GridColDef[] = [
    { field: 'name', headerName: 'Feldname', flex: 2 },
    { field: 'nummer', headerName: 'Feldnummer', flex: 2 },
    // { field: 'breitengrad', headerName: 'Breitengrad', flex: 2 },
    // { field: 'laengengrad', headerName: 'Längengrad', flex: 2 },
    { field: 'umspannwerk', headerName: 'Umspannwerk', flex: 2 }
  ]

  function printTableSchaltfeld(data: schaltfeld[]) {
    return (
      <Container maxWidth={false} className={classes.root}>
        <div style={{ height: "50vh", width: '100%' }}>
          <DataGrid
            localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
            disableColumnMenu={false}
            disableColumnSelector={true}
            columns={dataGridCols2}
            getRowId={(row) => row.name + row.umspannwerk}
            rows={data}
            sortModel={sorting}
            onSortModelChange={(model) => setSorting(model.sortModel)}
            onRowClick={(param: GridRowParams) => {
              let sf = schaltfeldDummy;
              const temp = data.find(sft => (sft.name == param.row.name && sft.umspannwerk == param.row.umspannwerk))
              if (temp)
                sf = temp;
              if (!editEntry) dispatch(updateAktuellesSchaltfeld(sf));
            }}
            loading={listLoading} />
        </div>
      </Container>
    );
  }

  function printSaveDiscardButtons() {
    return (<div>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(createSchaltfeld(aktuellesSchaltfeld)) : dispatch(updateSchaltfeld(aktuellesSchaltfeld)) }}
        color="secondary"
        className={classes.showtriButton}
        disabled={
          aktuellesSchaltfeld.name == ""
          // || aktuellesSchaltfeld.nummer == ""
          // || aktuellesSchaltfeld.breitengrad == null
          // || aktuellesSchaltfeld.laengengrad == null
          || aktuellesSchaltfeld.umspannwerk == ""
          || !dirtyEdit
          || inputError}
        style={{ minHeight: "36px" }}
      >
        {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
      </Button>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
        color="secondary"
        className={classes.showtriButton}
      >
        Abbrechen
      </Button>
    </div>)
  }
  function confirmDeleteOfRoutergeraet() {
    dispatch(deleteSchaltfeld(aktuellesSchaltfeld));
    setOpenDeleteDialog(false);
  }

  function printEditDeleteButton() {
    if (isAuthorized([rollenObj.admin, rollenObj.betrieb]))
      return (
        <div>

          <Button
            variant="contained"
            onClick={() => dispatch(setEditEntry())}
            color="secondary"
            className={classes.showtriButton}
          >
            Bearbeiten
          </Button>
          {!aktuellesSchaltfeld.zugeordnet ?
            <Button
              variant="contained"
              onClick={() => setOpenDeleteDialog(true)}
              color="secondary"
              className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
            >
              Löschen
            </Button> : ""}
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>Schaltfeld löschen</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {'Sind Sie sicher, dass Sie das Schaltfeld "' +
                  aktuellesSchaltfeld.name +
                  '" wirklich löschen wollen?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenDeleteDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                variant="contained"
                onClick={confirmDeleteOfRoutergeraet}
                className={classes.confirmDeleteButton}
                style={{ minWidth: "120px", minHeight: "36px" }}
              >
                {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
              </Button>
            </DialogActions>
          </Dialog>
          <Button
            variant="contained"
            onClick={() => { dispatch(resetViewMode()) }}
            color="default"
            className={classes.showtriButton}
          >
            Schließen
          </Button>
        </div>
      );
    else return (<React.Fragment />)
  }

  function printEdit() {

    return (
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }}>
        <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
          <div>
            <Grid container spacing={4}>
              <Grid item container xs={12}>
                <Grid item md={3} >
                  <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"} >
                    {newEntry ? "Neues Schaltfeld anlegen" : "Bearbeiten von Schaltfeld: " + aktuellesSchaltfeld.name}
                  </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6}>
                  {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id="schaltfeld-name"
                    disabled={newEntry ? false : true}
                    label="Feldname"
                    error={validate(dispatch, setError, resetError, aktuellesSchaltfeld.name, "name")}
                    helperText={validateHelper(aktuellesSchaltfeld.name)}
                    variant="outlined"
                    onChange={(event) => dispatch(setName(event.target.value))}
                    value={aktuellesSchaltfeld.name}
                  />
                </FormControl>
              </Grid>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={false}
                    id="schaltfeld-nummer"
                    disabled={editEntry ? false : true}
                    label="Feldnummer"
                    error={validate(dispatch, setError, resetError, aktuellesSchaltfeld.nummer, "nummer")}
                    helperText={validateHelper(aktuellesSchaltfeld.nummer)}
                    variant="outlined"
                    onChange={(event) => dispatch(setNummer(event.target.value))}
                    value={aktuellesSchaltfeld.nummer}
                  />
                </FormControl>
              </Grid>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    id="select-schaltfelder-uw"
                    disabled={newEntry ? false : true}
                    value={aktuellesSchaltfeld.umspannwerk}
                    noOptionsText={<React.Fragment>
                      {uwLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Umspannwerke"}</React.Fragment>
                    }
                    onChange={(_, newValue) => {
                      if (newValue) dispatch(setUmspannwerk(newValue));
                    }}
                    inputValue={uwSelectInputValue}
                    onInputChange={(event, newInputValue) => {
                      setUwSelectInputValue(newInputValue);
                    }}
                    options={uwSelectList.map((x) => x.name)}
                    getOptionLabel={(option) => (option ? option : "")}
                    renderInput={(params) => (
                      <TextField
                        required={true}
                        {...params}
                        label="Umspannwerk"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>

                  <TextField
                    id="schaltfeld-laengengrad"
                    disabled={editEntry ? false : true}
                    label="Längengrad"
                    type="number"
                    error={validate(dispatch, setError, resetError, aktuellesSchaltfeld.laengengrad.toString(), "laengengrad")}
                    helperText={validateHelper(aktuellesSchaltfeld.laengengrad.toString())}
                    variant="outlined"
                    onChange={(event) => dispatch(setLaengengrad(Number(event.target.value)))}
                    value={aktuellesSchaltfeld.laengengrad}
                  />
                </FormControl>
              </Grid>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="schaltfeld-breitengrad"
                    disabled={editEntry ? false : true}
                    label="Breitengrad"
                    type="number"
                    name="numberformat"
                    error={validate(dispatch, setError, resetError, aktuellesSchaltfeld.breitengrad.toString(), "breitengrad")}
                    helperText={validateHelper(aktuellesSchaltfeld.breitengrad.toString())}
                    variant="outlined"
                    onChange={(event) => dispatch(setBreitengrad(Number(event.target.value)))}
                    value={aktuellesSchaltfeld.breitengrad}
                  />
                </FormControl>
              </Grid>
            </Grid> */}
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    disabled={editEntry ? false : true}
                    id="schaltfeld-kommentar"
                    multiline
                    rows={4}
                    rowsMax={8}
                    label="Kommentar"
                    error={validate(dispatch, setError, resetError, aktuellesSchaltfeld.kommentar, "kommentar")}
                    helperText={validateHelper(aktuellesSchaltfeld.kommentar)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                    value={aktuellesSchaltfeld.kommentar ? aktuellesSchaltfeld.kommentar : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    )
  }

  const [uwSelectInputValue, setUwSelectInputValue] = React.useState("");

  return (
    <div>
      {viewMode ? printEdit() : ""}
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid item md={3} >
            <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
              Schaltfelder Übersicht
            </Typography>
          </Grid>
          <Grid item md={3} />
          <Grid item md={6} style={{ paddingRight: "24px", paddingTop: "0px" }}>
            <Grid item container md={12}>
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3}>
                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                  <Button
                    variant="contained"
                    onClick={() => dispatch(startNewEntry())}
                    color="secondary"
                    className={classes.showButton}
                    disabled={editEntry ? true : false}
                  >
                    Hinzufügen
                  </Button>
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          {printTableSchaltfeld(schaltfeldSelectListe)}
        </Grid>
      </Paper>
    </div>
  );
}
